export const actionTypes = {
    SET_FOOD_CHOICE_REQ: 'SET_FOOD_CHOICE_REQ',
    SET_FOOD_CHOICE_SUCCESS: 'SET_FOOD_CHOICE_SUCCESS',
}

export const setFoodChoiceReq = payload => ({
    type: actionTypes.SET_FOOD_CHOICE_REQ,
    payload,
})

export const setFoodChoiceSuccess = payload => ({
    type: actionTypes.SET_FOOD_CHOICE_SUCCESS,
    payload,
})
